<template>
  <div class="page-add">
    <div class="add-title">{{ title }}</div>
    <el-form
      class="form"
      size="small"
      label-position="right"
      label-width="130px"
      :rules="rules"
      :model="subjectForm"
      ref="subjectForm"
    >
      <el-row>
        <el-col>
          <el-form-item class="scale" label=" APP是否展示：" required>
            <el-radio-group
              v-model="subjectForm.isApp"
              :disabled="subjectForm.onlineStatus == 1"
            >
              <el-radio
                v-for="item in publicData"
                :key="item.paramKey"
                :label="item.paramKey"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="scale" label=" WEB是否展示：" required>
            <el-radio-group
              v-model="subjectForm.isWeb"
              :disabled="subjectForm.onlineStatus == 1"
            >
              <el-radio
                v-for="item in publicData"
                :key="item.paramKey"
                :label="item.paramKey"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="scale" label=" 小程序是否展示：" required>
            <el-radio-group
              v-model="subjectForm.isApplet"
              :disabled="subjectForm.onlineStatus == 1"
            >
              <el-radio
                v-for="item in publicData"
                :key="item.paramKey"
                :label="item.paramKey"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="scale" label=" PC端是否展示：" required>
            <el-radio-group
              v-model="subjectForm.isPc"
              :disabled="subjectForm.onlineStatus == 1"
            >
              <el-radio
                v-for="item in publicData"
                :key="item.paramKey"
                :label="item.paramKey"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="专题名称：" prop="subjectName">
            <el-input
              v-model="subjectForm.subjectName"
              placeholder="请输入专题名称"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="专题标签：">
            <el-input
              maxlength="6"
              v-model="subjectForm.subjectTag"
              placeholder="请输入专题标签"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="专题简介：" prop="subjectDesc">
            <el-input
              v-model="subjectForm.subjectDesc"
              placeholder="请输入专题简介"
              type="textarea"
              :rows="2"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- <el-row>
        <el-col>
          <el-form-item class="scale" label="专题排序：" prop="order" required>
            <el-input-number
              v-model="subjectForm.order"
              :min="0"
              :max="100"
              label="描述文字"
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row> -->
      <el-row>
        <div style="width: 95%">
          <el-col :span="8" v-if="subjectForm.isWeb == '1'">
            <el-form-item class="scale" label="配图：" prop="webCover">
              <div
                v-if="subjectForm.webCover"
                id="video-output"
                @mouseenter="showCover1 = true"
                @mouseleave="showCover1 = false"
              >
                <img :src="subjectForm.webCover" class="avatar" />
                <div v-show="showCover1" class="cover-bg">
                  <i
                    class="el-icon-zoom-in delete"
                    @click.stop="showViewer1 = true"
                  ></i>
                  <i
                    class="el-icon-delete delete"
                    @click.stop="deleteCover(1)"
                  ></i>
                </div>
              </div>
              <el-upload
                v-else
                action=""
                class="avatar-uploader"
                :show-file-list="false"
                :http-request="uploadCover1"
                accept="png,jpg,jpeg"
                :limit="1"
                ref="coverUpload1"
              >
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <label v-if="!subjectForm.webCover" class="upload-text"
                  >上传图片</label
                >
              </el-upload>
              <div class="upload_tip">
                <p>WEB封面</p>
                <p class="img_tip">建议尺寸：1200px*500px（或12:5）</p>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="subjectForm.isApp == '1'">
            <el-form-item
              :label="subjectForm.isWeb == '0' ? '配图：' : ''"
              class="scale"
              prop="appCover"
            >
              <div
                v-if="subjectForm.appCover"
                id="video-output"
                @mouseenter="showCover2 = true"
                @mouseleave="showCover2 = false"
              >
                <img :src="subjectForm.appCover" class="avatar" />
                <div v-show="showCover2" class="cover-bg">
                  <i
                    class="el-icon-zoom-in delete"
                    @click.stop="showViewer2 = true"
                  ></i>
                  <i
                    class="el-icon-delete delete"
                    @click.stop="deleteCover(2)"
                  ></i>
                </div>
              </div>
              <el-upload
                v-else
                action=""
                class="avatar-uploader"
                :show-file-list="false"
                :http-request="uploadCover2"
                accept="png,jpg,jpeg"
                :limit="1"
                ref="coverUpload2"
              >
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <label v-if="!subjectForm.appCover" class="upload-text"
                  >上传图片</label
                >
              </el-upload>
              <div class="upload_tip">
                <p>APP封面</p>
                <p class="img_tip">建议尺寸：1125px*562px（或2:1）</p>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="subjectForm.isApplet == '1'">
            <el-form-item
              :label="
                subjectForm.isWeb == '0' && subjectForm.isApp == '0'
                  ? '配图：'
                  : ''
              "
              class="scale"
              prop="dingCover"
            >
              <div
                v-if="subjectForm.dingCover"
                id="video-output"
                @mouseenter="showCover4 = true"
                @mouseleave="showCover4 = false"
              >
                <img :src="subjectForm.dingCover" class="avatar" />
                <div v-show="showCover4" class="cover-bg">
                  <i
                    class="el-icon-zoom-in delete"
                    @click.stop="showViewer4 = true"
                  ></i>
                  <i
                    class="el-icon-delete delete"
                    @click.stop="deleteCover(4)"
                  ></i>
                </div>
              </div>
              <el-upload
                v-else
                action=""
                class="avatar-uploader"
                :show-file-list="false"
                :http-request="uploadCover4"
                accept="png,jpg,jpeg"
                :limit="1"
                ref="coverUpload4"
              >
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <label v-if="!subjectForm.dingCover" class="upload-text"
                  >上传图片</label
                >
              </el-upload>
              <div class="upload_tip">
                <p>小程序封面</p>
                <p class="img_tip">建议尺寸：1125px*468px（或12:5）</p>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="subjectForm.isPc == '1'">
            <el-form-item
              class="scale"
              :label="
                subjectForm.isWeb == '0' &&
                subjectForm.isApp == '0' &&
                subjectForm.isApplet == '0'
                  ? '配图：'
                  : ''
              "
              prop="pcCover"
            >
              <div
                v-if="subjectForm.pcCover"
                id="video-output"
                @mouseenter="showCover5 = true"
                @mouseleave="showCover5 = false"
              >
                <img :src="subjectForm.pcCover" class="avatar" />
                <div v-show="showCover5" class="cover-bg">
                  <i
                    class="el-icon-zoom-in delete"
                    @click.stop="showViewer5 = true"
                  ></i>
                  <i
                    class="el-icon-delete delete"
                    @click.stop="deleteCover(5)"
                  ></i>
                </div>
              </div>
              <el-upload
                v-else
                action=""
                class="avatar-uploader"
                :show-file-list="false"
                :http-request="uploadCover5"
                accept="png,jpg,jpeg"
                :limit="1"
                ref="coverUpload5"
              >
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <label v-if="!subjectForm.pcCover" class="upload-text"
                  >上传图片</label
                >
              </el-upload>
              <div class="upload_tip">
                <p>PC端封面</p>
                <p class="img_tip">建议尺寸：根据实际显示位置设置尺寸</p>
              </div>
            </el-form-item>
          </el-col>
        </div>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="scale" label="专题背景：" prop="bgCover">
            <div
              v-if="subjectForm.bgCover"
              id="video-output"
              @mouseenter="showCover3 = true"
              @mouseleave="showCover3 = false"
            >
              <img :src="subjectForm.bgCover" class="avatar" />
              <div v-show="showCover3" class="cover-bg">
                <i
                  class="el-icon-zoom-in delete"
                  @click.stop="showViewer3 = true"
                ></i>
                <i
                  class="el-icon-delete delete"
                  @click.stop="deleteCover(3)"
                ></i>
              </div>
            </div>
            <el-upload
              v-else
              action=""
              class="avatar-uploader"
              :show-file-list="false"
              :http-request="uploadCover3"
              accept="png,jpg,jpeg"
              :limit="1"
              ref="coverUpload3"
            >
              <i class="el-icon-plus avatar-uploader-icon"></i>
              <label v-if="!subjectForm.bgCover" class="upload-text"
                >上传图片</label
              >
            </el-upload>
            <div class="upload_tip">
              <p>专题背景</p>
              <p class="img_tip">建议尺寸：1200px*500px（或12:5）</p>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="divide-line"></div>
      <el-form-item label="专题版块：" prop="subjectBlockList">
        <el-row>
          <el-col
            :span="colNum"
            v-for="(item, index) in subjectForm.subjectBlockList"
            :key="index + item.blockName"
          >
            <div class="subjectBlock">
              <div class="subjectBlock-top">
                <div class="blockName">
                  <img
                    v-if="item.blockType == 0"
                    src="../../../assets/image/video_block_icon.png"
                  />
                  <img
                    v-else-if="item.blockType == 1"
                    src="../../../assets/image/news_block_icon.png"
                  />
                  <img
                    v-else-if="item.blockType == 2"
                    src="../../../assets/image/book_block_icon.png"
                  />
                  <img
                    v-else
                    src="../../../assets/image/magazine_block_icon.png"
                  />
                  <span :title="item.blockName">{{ item.blockName }}</span>
                </div>
                <p>版块类型：{{ item.blockTypeName }}</p>
                <p>版块状态：{{ item.onlineStatusName }}</p>
              </div>
              <div class="subjectBlock-footer">
                <div
                  class="footer-item"
                  @click.prevent="updateOnlineStatus(item)"
                  v-if="item.onlineStatus == 0"
                >
                  <el-tooltip content="上线" placement="top">
                    <img src="../../../assets/image/block_up_icon.png" />
                  </el-tooltip>
                </div>
                <div
                  class="footer-item"
                  @click.prevent="updateOnlineStatus(item)"
                  v-if="item.onlineStatus == 1"
                >
                  <el-tooltip content="下线" placement="top">
                    <img src="../../../assets/image/block_down_icon.png" />
                  </el-tooltip>
                </div>
                <div class="footer-item" @click="openUpdate(index, item)">
                  <el-tooltip content="编辑" placement="top">
                    <img src="../../../assets/image/block_edit_icon.png" />
                  </el-tooltip>
                </div>
                <div class="footer-item" @click="leftOption(index)">
                  <el-tooltip content="左移" placement="top">
                    <img src="../../../assets/image/block_left_icon.png" />
                  </el-tooltip>
                </div>
                <div class="footer-item" @click="rightOption(index)">
                  <el-tooltip content="右移" placement="top">
                    <img src="../../../assets/image/block_right_icon.png" />
                  </el-tooltip>
                </div>
                <div class="footer-item" @click="deleteOption(index)">
                  <el-tooltip content="删除" placement="top">
                    <img src="../../../assets/image/block_delete_icon.png" />
                  </el-tooltip>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="colNum" v-if="subjectForm.subjectBlockList.length < 20">
            <div class="subjectBlock flex-column" @click="openCreated">
              <i class="el-icon-plus avatar-uploader-icon"></i>
              新增版块
            </div>
          </el-col>
        </el-row>
      </el-form-item>
      <el-row>
        <el-col>
          <el-form-item
            class="form-handle"
            label-width="0"
            v-if="$route.query.flag == 0"
          >
            <el-button @click="resetForm">重置</el-button>
            <el-button @click="goBack">返回</el-button>
            <el-button type="primary" @click="submit">提交</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-image-viewer
      v-if="showViewer1"
      :on-close="
        () => {
          showViewer1 = false;
        }
      "
      :url-list="[subjectForm.webCover]"
    />
    <el-image-viewer
      v-if="showViewer2"
      :on-close="
        () => {
          showViewer2 = false;
        }
      "
      :url-list="[subjectForm.appCover]"
    />
    <el-image-viewer
      v-if="showViewer4"
      :on-close="
        () => {
          showViewer4 = false;
        }
      "
      :url-list="[subjectForm.dingCover]"
    />
    <el-image-viewer
      v-if="showViewer3"
      :on-close="
        () => {
          showViewer3 = false;
        }
      "
      :url-list="[subjectForm.bgCover]"
    />
    <el-image-viewer
      v-if="showViewer5"
      :on-close="
        () => {
          showViewer5 = false;
        }
      "
      :url-list="[subjectForm.pcCover]"
    />
    <!-- 版块编辑新增 -->
    <Curd @click="oNclick(dataName)" />
  </div>
</template>

<script>
import {
  getSubjectInfo,
  saveSubjectInfo,
  updateSubjectInfo,
} from "@/api/subjectInfo";
import { getSysParamByTypes } from "@/api/sysParam";
import { Confirm } from "@/components/Confirm";
import vue from "@/main.js";
import FileHandler from "@/utils/file";
import rulesFactory from "@/utils/rules";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import { setItem } from "../../../utils/storage";
import Curd from "./curd";

export default {
  components: { ElImageViewer, Curd },
  data() {
    return {
      subjectForm: {
        subjectName: "",
        subjectTag: "",
        subjectDesc: "",
        webCover: "",
        appCover: "",
        dingCover: "",
        bgCover: "",
        pcCover: "",
        isApp: "",
        isWeb: "",
        isApplet: "",
        isPc: "",
        subjectBlockList: [],
      },
      publicData: [],
      title: "新增专题",
      index: -1,
      checkArray: [],
      rules: {
        subjectName: [
          rulesFactory.required("请填写专题名称"),
          rulesFactory.size("最多输入50个字", 0, 50),
        ],
        subjectDesc: [
          rulesFactory.required("请填写专题简介"),
          rulesFactory.size("最多输入300个字", 0, 300),
        ],
        webCover: [rulesFactory.required("请上传WEB封面")],
        appCover: [rulesFactory.required("请上传APP封面")],
        dingCover: [rulesFactory.required("请上传小程序封面")],
        pcCover: [rulesFactory.required("请上传PC封面")],
        bgCover: [rulesFactory.required("请上传专题背景")],
        subjectBlockList: [rulesFactory.required("请添加专题版块")],
      },
      showCover1: false,
      showCover2: false,
      showCover3: false,
      showCover4: false,
      showCover5: false,
      showViewer1: false,
      showViewer2: false,
      showViewer3: false,
      showViewer4: false,
      showViewer5: false,
      command: saveSubjectInfo,
      colNum: 8,
    };
  },
  computed: {
    questionIds() {
      return this.checkArray.map((item) => item.uuid);
    },
  },
  created() {
    this.getSysParamByTypes([
      "RECOMMEND_TAG",
      "VIDEO_SOURCE",
      "VIDEO_TYPE",
      "IS_VALID",
    ]);
    var _this = this;
    _this.listenScreenWidth();
    vue.$on("addSubjectBlock", function (item) {
      _this.subjectForm.subjectBlockList.push(JSON.parse(item));
    });
    vue.$on("editSubjectBlock", function (item) {
      _this.$set(
        _this.subjectForm.subjectBlockList,
        _this.index,
        JSON.parse(item)
      );
      _this.index = -1;
    });
    if (this.$route.query.uuid) {
      _this.title = "编辑专题";
      _this.command = updateSubjectInfo;
      getSubjectInfo({ uuid: this.$route.query.uuid }).then((res) => {
        if (!res || res.code != 0) return;
        this.subjectForm = res.data;
        this.subjectForm.isApplet = String(this.subjectForm.isApplet);
        this.subjectForm.isApp = String(this.subjectForm.isApp);
        this.subjectForm.isWeb = String(this.subjectForm.isWeb);
        this.subjectForm.isPc = this.subjectForm.isPc == 1 ? "1" : "0";
        this.edituuid = res.data.uuid;
      });
    }
  },
  mounted() {
    window.onresize = () => {
      (() => {
        this.listenScreenWidth();
      })();
    };
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        this.publicData = res.data["IS_VALID"] || [];
        if(!this.$route.query.uuid) {
          this.subjectForm.isApp = this.publicData[1].paramKey;
          this.subjectForm.isWeb = this.publicData[1].paramKey;
          this.subjectForm.isApplet = this.publicData[1].paramKey;
          this.subjectForm.isPc = this.publicData[1].paramKey;
        }
        
      });
    },
    goBack() {
      this.$router.push("/subjectInfo");
    },
    // 监听屏幕宽度，设置排版
    listenScreenWidth() {
      this.colNum = 8;
      window.screenWidth = document.body.clientWidth;
      let screenWidth = window.screenWidth;
      if (screenWidth > 1680) {
        this.colNum = 6;
      }
    },
    //新增版块
    openCreated() {
      vue.$emit("handleSubjectBlock");
    },
    //修改版块
    openUpdate(i, item) {
      this.index = i;
      vue.$emit("handleSubjectBlock", item);
    },
    //版块上下线
    updateOnlineStatus(item) {
      item.onlineStatus = item.onlineStatus == 0 ? 1 : 0;
      item.onlineStatusName = item.onlineStatus == 0 ? "下线" : "上线";
    },
    //删除版块
    deleteOption(index) {
      this.subjectForm.subjectBlockList.splice(index, 1);
    },
    //左移版块
    leftOption(i) {
      if (i > 0) {
        var tempOption = this.subjectForm.subjectBlockList[i - 1];
        this.$set(
          this.subjectForm.subjectBlockList,
          i - 1,
          this.subjectForm.subjectBlockList[i]
        );
        this.$set(this.subjectForm.subjectBlockList, i, tempOption);
      }
    },
    //右移版块
    rightOption(i) {
      if (i < this.subjectForm.subjectBlockList.length - 1) {
        var tempOption = this.subjectForm.subjectBlockList[i + 1];
        this.$set(
          this.subjectForm.subjectBlockList,
          i + 1,
          this.subjectForm.subjectBlockList[i]
        );
        this.$set(this.subjectForm.subjectBlockList, i, tempOption);
      }
    },
    // 上传WEB封面
    async uploadCover1(e) {
      let file = e.file;
      // 校验文件格式是否符合要求(png格式或者jpg格式)
      const image = await FileHandler.isImage(file);
      const gif = await FileHandler.isGif(file);
      if (!(image || gif)) {
        this.$message({
          message:
            "请上传格式为png、jpg、gif格式的文件，其余文件格式无法上传哦！",
          type: "warning",
        });
        // 重点: 异常流程时必须要清除上传的文件，否则设置限制文件上传数量为1时不能再次执行上传事件
        this.$refs["coverUpload1"].clearFiles();
        return;
      }
      FileHandler.uploadFile(`subject/img`, file).then((res) => {
        const { url } = res;
        this.subjectForm.webCover = url;
      });
    },
    // 上传封面
    async uploadCover2(e) {
      let file = e.file;
      // 校验文件格式是否符合要求(png格式或者jpg格式)
      const image = await FileHandler.isImage(file);
      const gif = await FileHandler.isGif(file);
      if (!(image || gif)) {
        this.$message({
          message:
            "请上传格式为png、jpg、gif格式的文件，其余文件格式无法上传哦！",
          type: "warning",
        });
        // 重点: 异常流程时必须要清除上传的文件，否则设置限制文件上传数量为1时不能再次执行上传事件
        this.$refs["coverUpload2"].clearFiles();
        return;
      }
      FileHandler.uploadFile(`subject/img`, file).then((res) => {
        const { url } = res;
        this.subjectForm.appCover = url;
      });
    },
    async uploadCover4(e) {
      let file = e.file;
      // 校验文件格式是否符合要求(png格式或者jpg格式)
      const image = await FileHandler.isImage(file);
      const gif = await FileHandler.isGif(file);
      if (!(image || gif)) {
        this.$message({
          message:
            "请上传格式为png、jpg、gif格式的文件，其余文件格式无法上传哦！",
          type: "warning",
        });
        // 重点: 异常流程时必须要清除上传的文件，否则设置限制文件上传数量为1时不能再次执行上传事件
        this.$refs["coverUpload4"].clearFiles();
        return;
      }
      const _URL = window.URL || window.webkitURL;
      const img = new Image();
      const src = _URL.createObjectURL(file);
      img.onload = () => {
        const width = img.naturalWidth;
        const height = img.naturalHeight;
        const names = file.name.split('.');
        const fileName = `${names[0]}_${width}*${height}.${names[1]}`;
        FileHandler.uploadFileByName(`subject/img`, file, fileName).then((res) => {
          const { url } = res;
          this.subjectForm.dingCover = url;
        });
      };
      img.src = src;
      
    },
    // 上传封面
    async uploadCover3(e) {
      let file = e.file;
      // 校验文件格式是否符合要求(png格式或者jpg格式)
      const image = await FileHandler.isImage(file);
      if (!image) {
        this.$message({
          message: "请上传格式为png、jpg格式的文件，其余文件格式无法上传哦！",
          type: "warning",
        });
        // 重点: 异常流程时必须要清除上传的文件，否则设置限制文件上传数量为1时不能再次执行上传事件
        this.$refs["coverUpload3"].clearFiles();
        return;
      }
      FileHandler.uploadFile(`subject/img`, file).then((res) => {
        const { url } = res;
        this.subjectForm.bgCover = url;
      });
    },
    async uploadCover5(e) {
      let file = e.file;
      // 校验文件格式是否符合要求(png格式或者jpg格式)
      const image = await FileHandler.isImage(file);
      const gif = await FileHandler.isGif(file);
      if (!(image || gif)) {
        this.$message({
          message:
            "请上传格式为png、jpg、gif格式的文件，其余文件格式无法上传哦！",
          type: "warning",
        });
        // 重点: 异常流程时必须要清除上传的文件，否则设置限制文件上传数量为1时不能再次执行上传事件
        this.$refs["coverUpload5"].clearFiles();
        return;
      }
      FileHandler.uploadFile(`subject/img`, file).then((res) => {
        const { url } = res;
        this.subjectForm.pcCover = url;
      });
    },
    // 删除封面
    deleteCover(index) {
      switch (index) {
        case 1: {
          this.subjectForm.webCover = "";
          break;
        }
        case 2: {
          this.subjectForm.appCover = "";
          break;
        }
        case 3: {
          this.subjectForm.bgCover = "";
          break;
        }
        case 4: {
          this.subjectForm.dingCover = "";
          break;
        }
        case 5: {
          this.subjectForm.pcCover = "";
          break;
        }
      }
    },
    backAdd() {
      this.addFlag = false;
    },
    async resetForm() {
      const text = "确定重置吗?";
      try {
        await Confirm(text, "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        this.$refs["subjectForm"].resetFields();
      } catch (error) {
        if (error === "cancel") return;
      }
    },
    selectChange(selections) {
      this.checkArray = selections;
    },
    //新增编辑专题
    submit() {
      // if (
      //   this.subjectForm.isApplet == "0" &&
      //   this.subjectForm.isApp == "0" &&
      //   this.subjectForm.isWeb == "0" &&
      //   this.subjectForm.isPc == "0"
      // ) {
      //   this.$message({
      //     message: "请至少选择一个终端展示!",
      //     type: "warning",
      //   });
      //   return;
      // }
      console.log(this.subjectForm);
      this.$refs["subjectForm"]
        .validate()
        .then(() => {
          let params = Object.assign({}, this.subjectForm);
          params["onlineStatus"] = Number(this.$route.query.onlineStatus) || 0;
          params["isRecommended"] = 0;
          params["enableShared"] = 1;
          this.command(params).then((res) => {
            if (!res || res.code != 0) return;
            this.$message.success(res.msg);
            // console.log('----', this.REFRESH_FLAG);
            setItem(this.REFRESH_FLAG, true);
            // console.log('----');
            this.goBack();
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
$textColor: #51627d;
$textSize: 12px;
@mixin text {
  color: $textColor;
  font-size: $textSize;
}
/deep/ .el-dialog__body {
  padding: 30px 30px 30px 20px;
}
.delete-choose {
  position: absolute;
  top: 10px;
  right: -19px;
  font-size: 14px;
  cursor: pointer;
}
/deep/ .scale .el-input {
  @include text;
}
.form-select {
  width: 100%;
  &.has-btn {
    width: calc(100% - 120px);
  }
}
.button-dept {
  margin-left: 10px;
  width: 100px;
}
.progress {
  outline: none;
  border: 1px dashed #d9d9d9;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  width: 360px;
  height: 180px;
}
.mr30 {
  margin-right: 30px;
}
.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  background-color: #f7f9fc;
  width: 280px;
  height: 160px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 70px;
  height: 70px;
  line-height: 70px;
  text-align: center;
}
.avatar {
  width: 280px;
  height: 160px;
  display: block;
  object-fit: contain;
}
.upload-text {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  color: $textColor;
  font-size: 13px;
}
.progress {
  outline: none;
  border: 1px dashed #d9d9d9;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  width: 360px;
  height: 180px;
}
.subjectBlock {
  height: 179px;
  width: 290px;
  border-radius: 6px;
  border: 1px solid rgba(237, 241, 248, 1);
  margin-bottom: 32px;
  margin-left: 40px;
  .subjectBlock-top {
    padding: 21px 32px 12px 32px;
    p {
      line-height: 17px;
      color: #51627d;
      margin-top: 20px;
    }
    .blockName {
      color: #343c4a;
      font-size: 14px;
      line-height: 20px;
      display: flex;
      align-items: center;
      span {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
      }
      img {
        width: 20px;
        height: auto;
        margin-right: 8px;
      }
    }
  }
  .subjectBlock-footer {
    height: 40px;
    width: 250px;
    position: relative;
    left: 0;
    bottom: 0;
    display: flex;
    background-color: #edf1f8;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    .footer-item {
      height: 100%;
      display: flex;
      align-items: center;
    }
    img {
      width: 21px;
      height: auto;
      cursor: pointer;
    }
  }
}
.subjectBlock:nth-child(3n + 1) {
  margin-left: 0px;
}
#video-output {
  width: 280px;
  height: 160px;
  position: relative;
  .cover-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(1, 1, 1, 0.5);
    z-index: 199;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    color: #ffffff;
    .delete {
      font-size: 20px;
      cursor: pointer;
    }
  }
}
.upload_tip {
  width: 280px;
  text-align: center;
  margin-top: 10px;
}
.upload_tip p {
  font-size: 14px;
  margin: 0;
  line-height: 30px;
  color: #51627d;
}
.upload_tip p.img_tip {
  font-size: 12px;
  color: #96a1b2;
}
.flex-column {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px dashed rgba(215, 219, 224, 1);
}
.divide-line {
  width: calc(100%-40px);
  height: 1px;
  background: #edf1f8;
  margin: 36px 20px 32px 20px;
}
</style>
